import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickContactCards = () => {
  const handleWhatsAppOrder = () => {
    window.open('https://wa.me/211915497014?text=Hello%20Chapati%20Plus!%20I%20would%20like%20to%20place%20an%20order.', '_blank');
  };

  const handleCall = () => {
    window.open('tel:+211915497014', '_self');
  };

  const handleEmail = () => {
    window.open('mailto:hello@chapatiplus.com', '_self');
  };

  const contactMethods = [
    {
      id: 1,
      icon: 'MessageCircle',
      title: 'WhatsApp Order',
      description: 'Quick and easy ordering through WhatsApp',
      action: 'Order Now',
      color: 'accent',
      onClick: handleWhatsAppOrder,
      details: '+211 915 497 014'
    },
    {
      id: 2,
      icon: 'Phone',
      title: 'Call Us',
      description: 'Speak directly with our team',
      action: 'Call Now',
      color: 'primary',
      onClick: handleCall,
      details: '+211 915 497 014'
    },
    {
      id: 3,
      icon: 'Mail',
      title: 'Email Us',
      description: 'Send us your questions or feedback',
      action: 'Send Email',
      color: 'secondary',
      onClick: handleEmail,
      details: 'hello@chapatiplus.com'
    }
  ];

  return (
    <section className="py-8 md:py-12 lg:py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Choose Your Preferred Contact Method
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            We offer multiple ways to reach us. Pick the one that works best for you!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {contactMethods?.map((method) => (
            <div
              key={method?.id}
              className="bg-card border border-border rounded-2xl p-6 md:p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-${method?.color}/10 rounded-xl mb-4 md:mb-6`}>
                <Icon name={method?.icon} size={28} color={`var(--color-${method?.color})`} className="md:w-8 md:h-8" />
              </div>

              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2 md:mb-3">
                {method?.title}
              </h3>

              <p className="text-sm md:text-base text-muted-foreground mb-3 md:mb-4">
                {method?.description}
              </p>

              <p className="text-base md:text-lg font-semibold text-foreground mb-4 md:mb-6">
                {method?.details}
              </p>

              <Button
                variant={method?.color === 'accent' ? 'default' : 'outline'}
                size="lg"
                fullWidth
                iconName={method?.icon}
                iconPosition="left"
                onClick={method?.onClick}
                className={method?.color === 'accent' ? 'bg-accent hover:bg-accent/90' : ''}
              >
                {method?.action}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickContactCards;